export default {
  shareScreen: "Vuoi condividere il tuo schermo?",
  no: "No",
  yes: "Sì",
  youmustpickastar: "Devi scegliere una valutazione",
  name: "Nome",
  email: "E-mail",
  phone: "Telefono",
  message: "Messaggio",
  sendMessage: "Invia messaggio",
  newConversation: "Nuova conversazione",
  sendpunctuation: "Invia feedback",
  musttypemail: "Devi inserire la tua e-mail",
  validemail: "Questa non è una e-mail valida",
  screenshare: "Condividi schermo",
  musttypename: "Devi inserire il tuo nome",
  musttypemessage: "Devi inserire un messaggio",
  configuration: "Configurazione",
  notifications: "Notifiche",
  notificationDetails: "Avvisami sui nuovi messaggi che ricevo in questa chat",
  close: "Chiudi",
  cancel: "Annulla",
  save: "Salva",
  willclose: "Chiusura chat",
  closeconf: "Sei sicuro di voler chiudere la chat?",
  conversationend: "La chat è terminata, vuoi chiuderla?",
  newmessage: "Nuovo messaggio",
  typehere: "Invia un messaggio...",
  whatdoyouthink: "Cosa pensi del servizio che hai ricevuto?",
  sendbymail: "Invia conversazione via e-mail",
  holdtimeavg: "Tempo di attesa medio",
  holdtime: "Il tuo tempo di attesa",
  messagesended: "Messaggio inviato!",
  emailerror: "Inserisci una e-mail valida per continuare",
  fieldserror: "Controlla i campi e riprova",
  messageserror: "Oops, qualcosa è andato storto :(",
  message: "Scrivi il tuo messaggio...",
  transfering: "Trasferendo...",
  endchat: "Termina chat",
  videocall: "Videochiamata",
  call: "Chiamata",
  openinextarnalwindow: "Apri in una finestra esterna",
  calling: "Chiamata in corso",
  callingduration: "Durata della chiamata",
  mute: "Disattiva audio",
  allowmicrophone: "Consenti accesso al microfono",
  hangup: "Riaggancia",
  duration: "Durata",
  write: "Scrivi",
  survey_title: "Speriamo che tu sia soddisfatto del servizio",
  survey_desc:
    "Ci piacerebbe sapere di più sulla tua esperienza con il nostro supporto, pensi di poter dedicare del tempo per darci un feedback?",
  available: "Disponibile",
  invalidextension: "Formato dell'allegato non valido",
  maxfilesize10mb: "Dimensione massima del file 10 MB",
  accessibility: "Accessibilità",
  accessibilityMenu: "Menu di accessibilità",
  "Font size": "Dimensione del carattere",
  emojis: {
    search: "Cerca",
    notfound: "Nessuna emoji trovata",
    title: "Scegli un'emoji",
    categories: {
      search: "Risultati della ricerca",
      recent: "Usati di frequente",
      people: "Faccine e persone",
      nature: "Animali e natura",
      foods: "Cibo e bevande",
      activity: "Attività",
      places: "Viaggi e luoghi",
      objects: "Oggetti",
      symbols: "Simboli",
      flags: "Bandiere",
      custom: "Personalizzati",
    },
  },
};
